<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7rTSoP/tc-custom/9781426880704.jpg?1726519033285" alt="This image is the cover for the book At the Spaniard's Pleasure"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">At the Spaniard's Pleasure
      </h1>
      <p class="bookDescription body article font2">
        <p>He was licensed to thrill!<br/><br/>When Nick Menendez discovered that beautiful Liza Summers was working for the prime suspect in a diamond robbery case, the Spanish security tycoon took matters into his own hands—and Liza into his custody! He decided the simplest way to uncover the truth <i>and</i> protect her was to take her to his bed—and keep her there until he knew her full involvement…</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jacqueline Baird
      </h2>
      
      <p class="authorDescription body article">When Jacqueline Baird is not busy writing she likes to spend her time travelling, reading and playing cards. She enjoys swimming in the sea when the weather allows. With a more sedentary lifestyle, she does visit a gym three times a week and has made the surprising discovery that she gets some of her best ideas while doing mind-numbingly boring exercises on the weight machines and airwalker. Jacqueline lives with her husband Jim in Northumberland.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?df1e95b0